import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../contexts/LanguageContext';

const { FiCoffee } = FiIcons;

const SponsorButton = () => {
  const [isSponsorOpen, setIsSponsorOpen] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState(5); // Default $5
  const { t } = useLanguage();

  // One-time payment links only
  const pricingPlans = [
    {
      name: "Small",
      amount: 5,
      paymentLink: "https://buy.stripe.com/6oU6oI7uPgxnc9VfX40Fi05",
      description: t('small')
    },
    {
      name: "Regular",
      amount: 8,
      paymentLink: "https://buy.stripe.com/00wfZieXhgxnb5R26e0Fi04",
      description: t('regular'),
      popular: true
    },
    {
      name: "Large",
      amount: 10,
      paymentLink: "https://buy.stripe.com/14A14og1l0yp6PB6mu0Fi06",
      description: t('large')
    }
  ];

  const handleSponsorClick = () => {
    setIsSponsorOpen(true);
    // Disable scrolling when modal is open
    document.body.style.overflow = 'hidden';
  };

  const handleClose = () => {
    setIsSponsorOpen(false);
    setSelectedAmount(5); // Reset selected amount
    // Re-enable scrolling when modal is closed
    document.body.style.overflow = 'auto';
  };

  const handleModalClick = (e) => {
    // Only close if clicking the overlay (background), not the modal content
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handlePaymentClick = (plan) => {
    // Get the payment link
    const paymentLink = plan.paymentLink;
    // Add product description to the URL
    const productName = `Beat Buddy 一次性贊助${plan.description}`;
    const finalUrl = new URL(paymentLink);
    // Open Stripe payment link in new tab
    window.open(finalUrl.toString(), '_blank', 'noopener,noreferrer');
    // Close the modal after opening payment link
    handleClose();
  };

  return (
    <>
      <button
        onClick={handleSponsorClick}
        className="p-2 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-md hover:shadow-lg transition-all duration-200 flex items-center space-x-2"
        title={t('sponsorNow')}
      >
        <SafeIcon icon={FiCoffee} className="w-4 h-4 text-white" />
        <span className="text-sm font-medium">
          {t('sponsorNow')}
        </span>
      </button>

      {isSponsorOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
          onClick={handleModalClick}
        >
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 w-full max-w-md relative">
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            >
              ✕
            </button>
            <div className="flex flex-col items-center text-center">
              <div className="text-4xl mb-4">☕</div>
              <h3 className="text-xl font-bold mb-4 text-gray-800 dark:text-gray-100">
                {t('supportBeatBuddy')}
              </h3>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                {t('sponsorDesc')}
              </p>

              {/* Sponsorship options */}
              <div className="grid grid-cols-3 gap-3 w-full mb-6">
                {pricingPlans.map((plan) => (
                  <button
                    key={plan.name}
                    onClick={() => setSelectedAmount(plan.amount)}
                    className={`p-4 rounded-lg transition-colors ${
                      selectedAmount === plan.amount
                        ? 'bg-gradient-to-r from-purple-100 to-pink-100 dark:from-purple-900 dark:to-pink-900 border-2 border-purple-300 dark:border-purple-700'
                        : 'bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600'
                    }`}
                  >
                    <p className="text-xl font-bold text-gray-800 dark:text-gray-200">${plan.amount}</p>
                    <p className="text-xs text-gray-600 dark:text-gray-400">{plan.description}</p>
                  </button>
                ))}
              </div>

              {/* Sponsor button */}
              <div className="w-full mb-4">
                <button
                  onClick={() => handlePaymentClick(pricingPlans.find(p => p.amount === selectedAmount))}
                  className="px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl font-bold hover:scale-105 transition-transform duration-200 w-full flex items-center justify-center"
                >
                  {t('sponsorNow')} ${selectedAmount}.00
                </button>
              </div>

              <p className="text-xs text-gray-500 dark:text-gray-400 mt-2 text-center w-full">
                {t('thankYouMessage')}
              </p>

              {/* Currency note */}
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-2 text-center w-full">
                {t('currencyNote')}
              </p>

              {/* Stripe logo */}
              <div className="mt-4 flex items-center justify-center">
                <div className="text-xs text-gray-500 dark:text-gray-400 mr-2">
                  {t('poweredBy')}
                </div>
                <span className="font-semibold text-blue-600 dark:text-blue-400">Stripe</span>
              </div>

              {/* Security note */}
              <div className="mt-3 flex items-center justify-center text-xs text-gray-500 dark:text-gray-400">
                <span>🔒 {t('securePayment')}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SponsorButton;